import { MARKETING_QUERY_PARAMS } from './marketingQueryParams.js';
const marketingParams = MARKETING_QUERY_PARAMS;
/**
 * Return a copy of the query with all marketing params removed.
 *
 * Used for canonical URLs: a landing page reached via `?utm_campaign=…` must canonicalise to the clean
 * page so search engines don't index campaign variants as duplicates.
 *
 * @__NO_SIDE_EFFECTS__
 */
export function stripMarketingParams(query) {
    const result = {};
    for (const key in query) {
        const value = query[key];
        if (value !== undefined && !marketingParams.includes(key)) {
            result[key] = value;
        }
    }
    return result;
}
//# sourceMappingURL=stripMarketingParams.js.map